var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeactivateAcount(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "deactivate-account"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29320",
    "data-name": "Rectangle 29320",
    width: 18,
    height: 18,
    transform: "translate(281 280)",
    fill: "#6a6f73",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11648",
    "data-name": "Group 11648",
    transform: "translate(-281 -426)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_698",
    "data-name": "Mask Group 698",
    transform: "translate(0 146)",
    clipPath: "url(#deactivate-account)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_-_2022-05-09T112435.596",
    "data-name": "svgexport-6 - 2022-05-09T112435.596",
    transform: "translate(282.491 280)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11684",
    "data-name": "Path 11684",
    d: "M7.4,8.671A4.2,4.2,0,0,0,10.461,7.4a4.2,4.2,0,0,0,1.27-3.065,4.2,4.2,0,0,0-1.27-3.065A4.2,4.2,0,0,0,7.4,0,4.2,4.2,0,0,0,4.33,1.27,4.2,4.2,0,0,0,3.06,4.335,4.2,4.2,0,0,0,4.33,7.4,4.2,4.2,0,0,0,7.4,8.671ZM5.076,2.016A3.134,3.134,0,0,1,7.4,1.055a3.134,3.134,0,0,1,2.319.961,3.134,3.134,0,0,1,.961,2.319,3.134,3.134,0,0,1-.961,2.319A3.134,3.134,0,0,1,7.4,7.616a3.135,3.135,0,0,1-2.319-.961,3.134,3.134,0,0,1-.961-2.319,3.134,3.134,0,0,1,.961-2.319Zm0,0",
    fill: "#6a6f73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11685",
    "data-name": "Path 11685",
    d: "M14.981,13.841a10.708,10.708,0,0,0-.146-1.137,8.961,8.961,0,0,0-.28-1.144,5.649,5.649,0,0,0-.47-1.066,4.02,4.02,0,0,0-.709-.924,3.125,3.125,0,0,0-1.018-.64,3.519,3.519,0,0,0-1.3-.235,1.319,1.319,0,0,0-.7.3c-.211.138-.458.3-.734.473a4.206,4.206,0,0,1-.95.418,3.688,3.688,0,0,1-2.323,0A4.193,4.193,0,0,1,5.4,9.467c-.273-.175-.52-.334-.735-.474a1.318,1.318,0,0,0-.7-.3,3.515,3.515,0,0,0-1.3.236,3.123,3.123,0,0,0-1.018.64,4.021,4.021,0,0,0-.709.924,5.659,5.659,0,0,0-.47,1.067A8.982,8.982,0,0,0,.182,12.7a10.635,10.635,0,0,0-.146,1.138C.012,14.185,0,14.543,0,14.9a2.989,2.989,0,0,0,.888,2.261A3.2,3.2,0,0,0,3.175,18h8.667a3.2,3.2,0,0,0,2.287-.834,2.988,2.988,0,0,0,.888-2.261c0-.363-.012-.72-.036-1.063ZM13.4,16.4a2.151,2.151,0,0,1-1.56.544H3.175a2.151,2.151,0,0,1-1.56-.544,1.952,1.952,0,0,1-.56-1.5c0-.337.011-.67.033-.99A9.593,9.593,0,0,1,1.22,12.89a7.922,7.922,0,0,1,.246-1.008,4.607,4.607,0,0,1,.383-.867,2.98,2.98,0,0,1,.521-.683,2.073,2.073,0,0,1,.677-.421,2.427,2.427,0,0,1,.831-.16c.037.02.1.057.209.127.217.141.467.3.743.479a5.226,5.226,0,0,0,1.192.533,4.742,4.742,0,0,0,2.972,0,5.232,5.232,0,0,0,1.193-.533c.283-.181.526-.337.743-.479.107-.069.172-.107.209-.127a2.429,2.429,0,0,1,.831.16,2.076,2.076,0,0,1,.677.421,2.972,2.972,0,0,1,.521.683,4.592,4.592,0,0,1,.383.867A7.9,7.9,0,0,1,13.8,12.89a9.674,9.674,0,0,1,.132,1.025h0c.022.318.034.651.034.99a1.952,1.952,0,0,1-.56,1.5Zm0,0",
    fill: "#6a6f73"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11647",
    "data-name": "Group 11647"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_604",
    "data-name": "Line 604",
    x1: 5,
    y2: 5,
    transform: "translate(287.5 437.5)",
    fill: "none",
    stroke: "#6a6f73",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_605",
    "data-name": "Line 605",
    x2: 5,
    y2: 5,
    transform: "translate(287.5 437.5)",
    fill: "none",
    stroke: "#6a6f73",
    strokeWidth: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactivateAcount);
export default __webpack_public_path__ + "static/media/deactivate-acount.0f1d47d30cd0ada8e8cf81bb2c992a66.svg";
export { ForwardRef as ReactComponent };